import { Input, EventEmitter, Output, Component } from "@angular/core";
import { SpeechRecognitionService } from "./speech-recognition.service";


@Component({
    selector: 'speech-search',
    template: `
    <div *ngIf="isChrome">
    <span class="fas-microphone-msg">{{showMsg}}</span>
    <i (click)="activateSpeechSearchMovie()" *ngIf="showSearchButton" class="fa fa-microphone fas-microphone"></i>
    <i (click)="stopSpeech()" *ngIf="!showSearchButton" class="fa fa-microphone-slash fas-microphone"></i>
    </div>
    `
})
export class SpeechSearchDirective {
    @Output() speechText: EventEmitter<any> = new EventEmitter();
    @Input() speechLang: string = "en-us"
    showSearchButton: boolean = true;
    showMsg: string = "";
    isChrome: boolean = false;
    constructor(private speechRecognitionService: SpeechRecognitionService) {
    }

    ngOnInit() {
        this.isChrome = (navigator.userAgent.indexOf("Chrome") != -1);
    }

    stopSpeech() {
        this.speechRecognitionService.DestroySpeechObject();
        this.showSearchButton = true;
        this.showMsg = "";
    }

    activateSpeechSearchMovie(): void {
        this.showSearchButton = false;
        this.showMsg = "";
        this.showMsg = "Speak Now...";
        this.speechRecognitionService.record(this.speechLang)
            .subscribe(
                //listener
                (value) => {
                    this.speechText.emit(value);
                },
                //errror
                (err) => {
                    console.log(err);
                    this.showMsg = "";
                    this.showSearchButton = true;
                    if (err.error == "no-speech") {
                        console.log("--restatring service--");
                        // this.activateSpeechSearchMovie();
                    }
                },
                //completion
                () => {
                    this.showMsg = "";
                    this.showSearchButton = true;
                    console.log("--complete--");
                    // this.activateSpeechSearchMovie();
                    this.stopSpeech();
                });
    }
    ngOnDestroy() {
        this.stopSpeech();
    }
}
